import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import { Brand } from '../../../lib/theme';
import { trackEvent } from '../../../lib/ga';

import providerCTAStyles from './ProviderCTA_styles';

import Button from '../../../components/presentational/Button';
import Spacer from '../../../components/presentational/Spacer';
import Typography from '../../../components/presentational/Typography';
import ResponsiveRender from '../../../behaviour/ResponsiveRender';

const gaLinkEvent = (category: string, action: string, label: string) => (
  event: any
) => {
  trackEvent({ category, action, label });

  if (!event.currentTarget || !event.currentTarget.href) {
    return true;
  }

  window.open(event.currentTarget.href, '_blank');
  event.preventDefault();

  return false;
};

export interface ProviderCTAProps {
  brand: Brand;
  banner: string;
  banner_mobile: string;
  banner_link: string;
  cta_btn_link: string;
  cta_btn_text: string;
  cta_text: string;
  logo: string;
  name: string;
  primary_colour: string;
  providerLogoURL: string;
  secondary_colour: string;
  wide_logo: string;
}

const DEFAULT_CTA_TEXT = 'Click here';

const ProviderCTA = ({
  brand,
  name,
  banner,
  banner_mobile,
  banner_link,
  cta_text,
  cta_btn_link,
  cta_btn_text,
  styles,
}: ProviderCTAProps & StylesProps<typeof providerCTAStyles>) => (
  <Spacer className={styles.container}>
    {banner && (
      <a href={banner_link ?? undefined} target="_blank">
        {banner_mobile && (
          <>
            <ResponsiveRender match="s">
              <div
                className={styles.banner}
              >
                <img src={banner_mobile} alt={name} />
              </div>
            </ResponsiveRender>
            <ResponsiveRender match="s" up>
              <div
                className={styles.banner}
              >
                <img src={banner} alt={name} />
              </div>
            </ResponsiveRender>
          </>
        )}

        {!banner_mobile && (
          <div
            className={styles.banner}
          >
            <img src={banner} alt={name} />
          </div>
        )}
      </a>
    )}
    <Spacer self={['s', 'm']} className={styles.content}>
      <Spacer className={styles.text} selfT={['xs', 's']} space={['xs', 's']}>
        <strong>{name}</strong>
        <Typography brand={brand}>
          <span dangerouslySetInnerHTML={{ __html: cta_text }} />
        </Typography>
      </Spacer>
      <a href={banner_link ?? undefined} target="_blank">
        <div className={styles.logo} />
      </a>
      <Button
        brand={brand}
        href={cta_btn_link}       
        target="_blank"
        className={styles.cta}
        onClick={gaLinkEvent('ARTICLE', 'CLICK', 'SPONSOR CTA')}
      >
        {cta_btn_text || DEFAULT_CTA_TEXT}
      </Button>
    </Spacer>
  </Spacer>
);

export default styled(providerCTAStyles)(ProviderCTA);
